import Swiper, { Autoplay } from "swiper";

export const initBranchSponsorsSlider = () => {
  let slider = document.querySelector('.branch-sponsors .swiper')
  let count = $('.branch-sponsors .swiper-wrapper').children().length

  if (count > 1) {
    new Swiper(slider, {
      modules: [Autoplay],
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      autoHeight: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      loop: true,
    })
  }
}
